<template>
  <div id="favorite" class="container">
    <section>
      <div class="section-group">
        <div class="row">
          <div class="col-md-3">
            <div class="card">
              <div class="card-body box-profile">
                <div class="text-center">
                  <!-- <img
                    class="profile-user-img img-fluid img-circle"
                    :src="customer.userLogoBig"
                    alt="User profile picture"
                  /> -->
                  <!-- <el-avatar
                    :src="customer.userLogoBig"
                    :size="100"
                  ></el-avatar> -->
                  <avatarVue
                    :src="`${customer.userLogoBig}?v=${getN()}`"
                    :size="100"
                  ></avatarVue>
                </div>
                <h3 class="profile-username text-center mb-1">
                  {{ customer.displayName }}
                </h3>
                  <div class="reward_center mt-2 mb-2">
                        <!-- 獎牌名單列表 -->
        				<div class="toooltip" v-for="(item, idx) in medalListData">
        					<img :src="item.sgL_URL" style="width:40px;">
        					<span class="toooltiptext">{{ item.sgL_Title }}<br/> 
        						<span class="exchange_point b-operate-btn" type="button" @click="showExchangePoint(item.id)">兌換為點數</span>
        					</span>
        				</div>
        			  </div>
                 <p class="text-center mb-1">現有點數：{{ Runningwater.sgL_AfterPoint ? Runningwater.sgL_AfterPoint : 0  }}</p>
                <p class="text-muted text-center">{{ customer.sgL_Myself }}</p>
              </div>
              <!-- /.card-body -->
              <div class="card-body">
                <ul>
                       <li class="profile-nav" v-if="customers">
                            <router-link :to="{ name: 'customerPublishLook', query: { 'authorId': customers.userId } }">
                         <i class="fas fa-user-circle fa-fw mr-1" />  {{ $t('Customer.customerPublish.Homepage') }}
                            </router-link>
                          </li>
                  <li class="profile-nav">
                    <router-link :to="{ name: 'customerPublish' }">
                      <i class="fas fa-share fa-fw mr-1"></i> {{ $t('Customer.customerFavorite.customerPublish') }}
                    </router-link>
                  </li>
                  <li class="profile-nav active">
                    <router-link :to="{ name: 'customerFavorite' }"
                      ><i class="fas fa-bookmark fa-fw mr-1"></i>  {{ $t('Customer.customerFavorite.customerFavorite') }}
                    </router-link>
                  </li>
                  <li class="profile-nav">
                    <router-link :to="{ name: 'customerPrivateMessage' }"
                      ><i class="fas fa-comments fa-fw mr-1"></i>  {{ $t('Customer.customerFavorite.customerPrivateMessage') }}
                    </router-link>
                  </li>
                  <!-- <li class="profile-nav">
                    <router-link :to="{ name: 'customerMessage' }"
                      ><i class="fas fa-comments fa-fw mr-1"></i> 我的留言
                    </router-link>
                  </li> -->
                  <li class="profile-nav">
                    <router-link :to="{ name: 'customerInfo' }"
                      ><i class="fas fa-cog fa-fw mr-1"></i>  {{ $t('Customer.customerFavorite.customerInfo') }}
                    </router-link>
                  </li>
                </ul>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <!-- /.col -->
          <div class="col-md-9 pl-md-4">
            <div class="card">
              <div class="card-header">
                <div class="row">
                  <div class="col-8">
                    <ul class="nav nav-pills" v-if="countList != null">
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{ active: show == 'album' }"
                          href="javascript:void(0);"
                          @click="showContent('album')"
                          data-toggle="tab"
                          > {{ $t('Customer.customerFavorite.album') }}<span class="count">{{
                            countList.photo
                          }}</span></a
                        >
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{ active: show == 'picture' }"
                          href="javascript:void(0);"
                          @click="showContent('picture')"
                          data-toggle="tab"
                          > {{ $t('Customer.customerFavorite.picture') }}<span class="count">{{
                            countList.photoDtl
                          }}</span></a
                        >
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{ active: show == 'movie' }"
                          href="javascript:void(0);"
                          @click="showContent('movie')"
                          data-toggle="tab"
                          > {{ $t('Customer.customerFavorite.movie') }}<span class="count">{{
                            countList.video
                          }}</span></a
                        >
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{ active: show == 'activity' }"
                          href="javascript:void(0);"
                          @click="showContent('activity')"
                          data-toggle="tab"
                          > {{ $t('Customer.customerFavorite.activity') }}<span class="count">{{
                            countList.activity
                          }}</span></a
                        >
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{ active: show == 'topic' }"
                          href="javascript:void(0);"
                          @click="showContent('topic')"
                          data-toggle="tab"
                          > {{ $t('Customer.customerFavorite.topic') }}<span class="count">{{
                            countList.newArticle
                          }}</span></a
                        >
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{ active: show == 'feed' }"
                          href="javascript:void(0);"
                          @click="showContent('feed')"
                          data-toggle="tab"
                          > {{ $t('Customer.customerFavorite.feed') }}<span class="count">{{
                            countList.moiveCommunity
                          }}</span></a
                        >
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{ active: show == 'blog' }"
                          href="javascript:void(0);"
                          @click="showContent('blog')"
                          data-toggle="tab"
                          > {{ $t('Customer.customerFavorite.blog') }}<span class="count">{{
                            countList.bLog
                          }}</span></a
                        >
                      </li>
                    </ul>
                  </div>
                  <!-- Search bar -->
                  <div class="col-4">
                    <div class="search2">
                      <el-input
                        :placeholder="$t('Customer.customerFavorite.search')"
                        suffix-icon="fas fa-search"
                        v-model="title"
                      ></el-input>
                    </div>
                  </div>
                  <!-- /.Search bar -->
                </div>
              </div>

              <!-- /.card-header -->
              <div class="card-body" v-show="show == 'album'">
                <!-- My Profile -->
                <div class="profile-album section-group" v-if="getalbumList">
                  <div class="empty-block">
                    <div class="empty-block-inner" v-if="dataList == true">
                       {{ $t('Customer.customerFavorite.loading') }}...
                    </div>
                    <div class="empty-block-inner" v-else> {{ $t('Customer.customerFavorite.empty') }}</div>
                  </div>
                </div>
                <div class="my-profile bookmark-album section-group" v-else>
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div
                          class="col-6 col-md-4 col-lg-3"
                          v-for="album in albumList"
                          :key="album.id"
                        >
                          <div class="album-card card">
                            <router-link
                              target="_blank"
                              :to="{
                                name: 'albumviewPhotostream',
                                query: { id: album.id },
                              }"
                            >
                              <div class="album-block">
                                <div class="album-thumbnail">
                                  <div class="album-responsive">
                                    <div class="album-sizer">
                                      <div
                                        class="album-image"
                                        :style="{
                                          backgroundImage:
                                            'url(' +
                                            `${album.photoImage}` +
                                            ')',
                                        }"
                                      ></div>
                                    </div>
                                  </div>
                                  <div class="album-photo-count">
                                    <span>{{
                                      album.sgL_PG_CPhotoQuantityF
                                    }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="album-info p-3">
                                <div
                                  class="album-title mb-2"
                                  :title="album.sgL_PG_CName"
                                >
                                  {{ album.sgL_PG_CName }}
                                </div>
                                <span class="album-user">{{
                                  album.sgL_Mem_DisplayName
                                }}</span>
                                <span class="album-upload-date">{{
                                  album.sgL_PG_CAddTimerI
                                }}</span>
                              </div>
                            </router-link>
                            <div class="actions">
                              <a
                                class="bookmark"
                                :title="$t('Customer.customerFavorite.uncollect')"
                                href="javascript:void(0)"
                                @click="
                                  addfavorite(
                                    album.id,
                                    album.sgL_PG_CMasterSort,
                                    0,
                                    null
                                  )
                                "
                                ><i class="fas fa-bookmark fa-fw"></i
                              ></a>
                              <a
                                class="share"
                                :title="$t('Customer.customerFavorite.share')"
                                href="javascript:void(0);"
                                @click="shareItem(album.id, 'photo')"
                                ><i class="fa fa-share fa-fw"></i
                              ></a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row my-5">
                        <div class="col-12 col-sm-6 col-xs-4">
                          <!--  引用分页组件 -->
                          <pagination
                            v-if="getPageShow"
                            :currentPage="pageParams.currentPage"
                            :total="pageParams.total"
                            :limit="pageParams.limit"
                            :small="true"
                            @handleCurrentChange="handleCurrentChange"
                            @handleSizeChange="handleSizeChange"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /.My Profile -->
              </div>
              <div class="card-body" v-show="show == 'picture'">
                <!-- My Profile -->
                <div class="profile-album section-group" v-if="getalbumList">
                  <div class="empty-block">
                    <div class="empty-block-inner" v-if="dataList == true">
                       {{ $t('Customer.customerFavorite.loading') }}...
                    </div>
                    <div class="empty-block-inner" v-else> {{ $t('Customer.customerFavorite.Nophoto') }}</div>
                  </div>
                </div>
                <div class="my-profile bookmark-photo section-group">
                  <div class="row">
                    <div class="col-12">
                      <div
                        class="card collapsed-card"
                        v-for="album in albumList"
                        :key="album.id"
                      >
                        <div class="card-header">
                          <h3 class="card-title">
                            <router-link
                              :to="{
                                name: 'albumviewPhotostream',
                                query: { id: album.id },
                              }"
                              >{{ album.sgL_PG_CName }}</router-link
                            >
                          </h3>
                          <span class="album-user ml-2"
                            > {{ $t('Customer.customerFavorite.uploader') }}: {{ album.sgL_Mem_DisplayName }}</span
                          >
                          <span class="album-upload-date ml-1"
                            > {{ $t('Customer.customerFavorite.Uploaddate') }}:{{ album.sgL_PG_CAddTimerF }}</span
                          >
                          <div class="card-tools">
                            <el-button
                              type="button"
                              @click="getFavoritePicture(album.id)"
                              class="btn btn-tool"
                              data-card-widget="collapse"
                            >
                              <i class="fas fa-plus"></i>
                            </el-button>
                          </div>
                        </div>
                        <div class="card-body">
                          <div class="row">
                            <div
                              class="col-md-6 col-lg-4 col-xl-3 py-1"
                              v-for="picture in album.pictureDtl"
                              :key="picture.id"
                            >
                              <div class="photo-card">
                                <router-link
                                  target="_blank"
                                  :to="{
                                    name: 'photoview',
                                    query: {
                                      Coid: picture.sgL_PG_Coid,
                                      Liid: picture.id,
                                    },
                                  }"
                                  ><img :src="picture.imageUrl_S"
                                /></router-link>
                                <div class="actions">
                                  <a
                                    class="bookmark"
                                    :title="$t('Customer.customerFavorite.uncollect')"
                                    href="javascript:void(0)"
                                    @click="
                                      addfavorite(
                                        album.id,
                                        album.sgL_PG_CMasterSort,
                                        1,
                                        picture.id
                                      )
                                    "
                                    ><i class="fas fa-bookmark fa-fw"></i>
                                  </a>
                                  <a
                                    class="share"
                                    :title="$t('Customer.customerFavorite.share')"
                                    href="javascript:;"
                                    @click="share(picture.id, 'photoview')"
                                    ><i class="fa fa-share fa-fw"></i
                                  ></a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row my-5">
                      <div class="col-12 col-sm-6 col-xs-4">
                        <!--  引用分页组件 -->
                        <pagination
                          v-if="getPageShow"
                          :currentPage="pageParams.currentPage"
                          :total="pageParams.total"
                          :limit="pageParams.limit"
                          :small="true"
                          @handleCurrentChange="handleCurrentChange"
                          @handleSizeChange="handleSizeChange"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /.My Profile -->
              </div>
              <div class="card-body" v-show="show == 'topic'">
                <!-- My Profile -->
                <div
                  class="profile-album section-group"
                  v-if="topicList == null"
                >
                  <div class="empty-block">
                    <div class="empty-block-inner" v-if="dataList == true">
                       {{ $t('Customer.customerFavorite.loading') }}...
                    </div>
                    <div class="empty-block-inner" v-else> {{ $t('Customer.customerFavorite.newslessness') }}</div>
                  </div>
                </div>
                <div class="my-profile bookmark-article section-group" v-else>
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div
                          class="col-12 col-sm-6 col-lg-4"
                          v-for="topic in topicList"
                          :key="topic.id"
                        >
                          <div class="article-card card">
                            <router-link
                              target="_blank"
                              v-bind:to="{
                                name: 'articleview',
                                query: {
                                  id: topic.id,
                                },
                              }"
                            >
                              <div class="article-block">
                                <div class="article-thumbnail">
                                  <div class="article-responsive">
                                    <div class="article-sizer">
                                      <div
                                        class="article-image"
                                        :style="{
                                          backgroundImage:
                                            'url(' +
                                            `${topic.sgL_ImageUrl}` +
                                            ')',
                                        }"
                                      ></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="article-info p-3">
                                <div
                                  class="article-title mb-2"
                                  :title="topic.sgL_Title"
                                >
                                  {{ topic.sgL_Title }}
                                </div>
                                <span class="article-category">{{
                                  topic.sgL_MasterSortF
                                }}</span>
                                <span class="article-upload-date">{{
                                  topic.sgL_UpdateTimeE
                                }}</span>
                              </div>
                            </router-link>
                            <div class="actions">
                              <a
                                class="bookmark"
                                :title="$t('Customer.customerFavorite.uncollect')"
                                href="javascript:void(0)"
                                @click="
                                  addfavorite(
                                    topic.id,
                                    topic.sgL_MasterSort,
                                    4,
                                    topic.id
                                  )
                                "
                                ><i class="fas fa-bookmark fa-fw"></i>
                              </a>
                              <a
                                class="share"
                                :title="$t('Customer.customerFavorite.share')"
                                href="javascript:void(0);"
                                @click="shareItem(topic.id, 'articleview')"
                                ><i class="fa fa-share fa-fw"></i
                              ></a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row my-5">
                        <div class="col-12 col-sm-6 col-xs-4">
                          <!--  引用分页组件 -->
                          <pagination
                            v-if="getPageShow"
                            :currentPage="pageParams.currentPage"
                            :total="pageParams.total"
                            :limit="pageParams.limit"
                            :small="true"
                            @handleCurrentChange="handleCurrentChange"
                            @handleSizeChange="handleSizeChange"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /.My Profile -->
              </div>
              <div class="card-body" v-show="show == 'movie'">
                <div
                  class="profile-album section-group"
                  v-if="movieList == null"
                >
                  <div class="empty-block">
                    <div class="empty-block-inner" v-if="dataList == true">
                       {{ $t('Customer.customerFavorite.loading') }}...
                    </div>
                    <div class="empty-block-inner" v-else> {{ $t('Customer.customerFavorite.anechoic') }}</div>
                  </div>
                </div>
                <!-- My Profile -->
                <div class="my-profile bookmark-video section-group" v-else>
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div
                          class="col-sm-12 col-md-6 col-lg-4"
                          v-for="movie in movieList"
                          :key="movie.id"
                        >
                          <div
                            class="res.data.result.itemscard video-card card"
                          >
                            <a
                              :href="`${base.evi}/videowatch/${movie.id}/video`"
                            >
                              <div class="video-block">
                                <div class="video-thumbnail">
                                  <div class="video-responsive">
                                    <div class="video-sizer">
                                      <div
                                        class="video-image"
                                        :style="{
                                          backgroundImage:
                                            'url(' + `${movie.imageFile}` + ')',
                                        }"
                                      ></div>
                                    </div>
                                  </div>
                                  <div class="video-duration">
                                    <span>{{
                                      movie.mov_VSourceTimeFormat
                                    }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="video-info p-3">
                                <div
                                  class="video-title mb-2"
                                  :title="movie.sgL_Mov_VSubject"
                                >
                                  {{ movie.sgL_Mov_VSubject }}
                                </div>
                                <span class="video-user mb-1">{{
                                  movie.sgL_Mem_DisplayName
                                }}</span>
                                <span class="video-upload-date">{{
                                  movie.sgL_Mov_VAddTimerH
                                }}</span>
                              </div>
                            </a>
                            <div class="actions">
                              <a
                                class="bookmark"
                                :title="$t('Customer.customerFavorite.uncollect')"
                                href="javascript:void(0)"
                                @click="
                                  addfavorite(
                                    movie.id,
                                    movie.sgL_MasterSort,
                                    2,
                                    null
                                  )
                                "
                                ><i class="fas fa-bookmark fa-fw"></i
                              ></a>
                              <a
                                class="share"
                                :title="$t('Customer.customerFavorite.share')"
                                href="javascript:;"
                                @click="share(movie.id, 'video')"
                                ><i class="fa fa-share fa-fw"></i
                              ></a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row my-5">
                        <div class="col-12 col-sm-6 col-xs-4">
                          <!--  引用分页组件 -->
                          <pagination
                            v-if="getPageShow"
                            :currentPage="pageParams.currentPage"
                            :total="pageParams.total"
                            :limit="pageParams.limit"
                            :small="true"
                            @handleCurrentChange="handleCurrentChange"
                            @handleSizeChange="handleSizeChange"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /.My Profile -->
              </div>

                <!-- 開始 -->
                <div class="card-body" v-show="show == 'feed'">
  <div class="row" style="border-bottom: 1px solid rgba(0, 0, 0, 0.125);margin-bottom: 10px;padding:5px">
    <ul class="nav nav-pills">
                        <li class="nav-item">
                          <a
                            class="nav-link"
                            :class="{ active: feedshow == 'film' }"
                            href="javascript:void(0);"
                            @click="feedshowContent('film')"
                            data-toggle="tab"
                            > {{ $t('Customer.customerFavorite.film') }}</a>
                        </li>
                        <li class="nav-item">
                          <a
                            class="nav-link"
                            :class="{ active: feedshow == 'photo' }"
                            href="javascript:void(0);"
                            @click="feedshowContent('photo')"
                            data-toggle="tab"
                            > {{ $t('Customer.customerFavorite.photo') }}</a>
                        </li>
                        <li class="nav-item">
                          <a
                            class="nav-link"
                            :class="{ active: feedshow == 'text' }"
                            href="javascript:void(0);"
                            @click="feedshowContent('text')"
                            data-toggle="tab"
                            > {{ $t('Customer.customerFavorite.text') }}</a>
                        </li>
                      </ul>

  </div>

                <!-- My Profile -->
                <div
                    class="profile-album section-group"
                    v-if="moiveCommunityList == null"
                  >
                    <div class="empty-block">
                      <div class="empty-block-inner" v-if="dataList == true">
                         {{ $t('Customer.customerFavorite.loading') }}...
                      </div>
                      <div class="empty-block-inner" v-else> {{ $t('Customer.customerFavorite.empty') }}</div>
                    </div>
                  </div>
                <div class="my-profile bookmark-album section-group" v-else>
                    <div class="row">
                      <div class="col-12">
                        <div class="row" v-if="feedshow == 'film' || feedshow == 'photo'">
                          <div
                            class="col-6 col-md-4 col-lg-3"
                            v-for="item in moiveCommunityList"
                            :key="item.id"
                          >
                            <div class="album-card card" >
                              <router-link
                                target="_blank"
                                :to="{
                                      name: 'feed',
                                      query: { id: item.id },
                                    }"
                              >
                              <div class="album-block">
                                  <div class="album-thumbnail">
                                    <div class="album-responsive">
                                      <div class="album-sizer">
                                        <div
                                          v-if="item.sgL_Type == 1"
                                          class="album-image"
                                          :style="{
                                                backgroundImage:
                                                  'url(' + `${IsNullOrEmpty(item.sgL_GroupId)? item.sgL_ImageTempURL: item.sgL_GroupImageTemplP[0]}` + ')',
                                              }">
                                              <div class="detailTool" v-if="!IsNullOrEmpty(item.sgL_GroupId)">
                                                <div  class="album-photo-count"
                                                                                      style=" height: 20px"
                                                                                    >
                                                                                      <span>{{
                                                                                        item.sgL_GroupImageTemplP.length
                                                                                      }}</span>
                                                                                    </div>
                                              </div>
                                       

                                        </div>
                                        <div class="album-image" v-else>
                                          <video-player
                                            class="video-player vjs-custom-skin"
                                            :playsinline="true"
                                            :options="playerOptions[item.id]"
                                            @play="onPlayerPlay($event, item.id)"
                                          ></video-player>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="album-info p-3">
                                  <div
                                    class="album-title mb-2"
                                    :title="item.sgL_Content"
                                  >
                                    {{ item.sgL_Content }}
                                  </div>
                                  <span class="album-user">{{
                                    item.sgL_UsersName
                                  }}</span>
                                  <span class="album-upload-date">{{
                                    item.sgL_PG_CAddTimerF
                                  }}</span>
                                </div>
                              </router-link>
                              <div class="actions">
                                <a
                                  class="bookmark"
                                  :title="$t('Customer.customerFavorite.uncollect')"
                                  href="javascript:void(0)"
                                  @click="addfavorite(item.id, item.sgL_Type, 5, null)
                                      "
                                  ><i class="fas fa-bookmark fa-fw"></i
                                ></a>
                                <a
                                  class="share"
                                  :title="$t('Customer.customerFavorite.share')"
                                  href="javascript:void(0);"
                                  @click="shareFunc(item)"
                                  ><i class="fa fa-share fa-fw"></i
                                ></a>
                              </div>
                            </div>
                       
                          </div>
                        </div>
                        <div class="row" v-else>
                                <el-table :data="moiveCommunityList" width="100%" :empty-text="$t('Customer.customerFavorite.empty')" :header-cell-style="{ background:'#f8f9fa', color:'#6c757d'}" >
                                            <el-table-column
                                              :label="$t('Customer.customerFavorite.text')"
                                              prop="sgL_Content"
                                            >
                                            </el-table-column>
                                        
                                            <el-table-column
                                              prop="sgL_PG_CAddTimerI"
                                              :label="$t('Customer.customerFavorite.date')"
                                              width="140"
                                            ></el-table-column>
                                            <el-table-column
                                              :label="$t('Customer.customerFavorite.Controls')"
                                              width="110"
                                            >
                                              <template slot-scope="scoped">
                                                <a
                                    class="bookmark"
                                    :title="$t('Customer.customerFavorite.uncollect')"
                                    href="javascript:void(0)"
                                    @click="addfavorite(scoped.row.id, scoped.row.sgL_Type, 5, null)
                                        "
                                    ><i class="fas fa-bookmark fa-fw"></i
                                  ></a>
                                  <router-link
                                  target="_blank"
                                  :title="$t('Customer.customerFavorite.view')"
                                  :to="{
                                        name: 'feed',
                                        query: { id: scoped.row.id },
                                      }"
                                > <i
                                                  class="fa fa-eye fa-fw mx-2"
                                                  aria-hidden="true"
                                                ></i
                                              ></router-link>
                                           
                                              </template>
                                            </el-table-column>
                                          </el-table>
                              </div>
                        <div class="row my-5">
                          <div class="col-12 col-sm-6 col-xs-4">
                            <!--  引用分页组件 -->
                            <pagination
                              v-if="getPageShow"
                              :currentPage="pageParams.currentPage"
                              :total="pageParams.total"
                              :limit="pageParams.limit"
                              :small="true"
                              @handleCurrentChange="handleCurrentChange"
                              @handleSizeChange="handleSizeChange"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                <!-- /.My Profile -->
              </div>
              <!-- /.card-body -->


              <!-- 結束 -->

              <div class="card-body" v-show="show == 'activity'">
                <!-- My Profile -->
                <div class="my-profile bookmark-event section-group">
                  <div class="row">
                    <div class="col-12">
                      <div class="card">
                        <div class="card-header">
                          <h3 class="card-title"> {{ $t('Customer.customerFavorite.Pastactivity') }}</h3>
                          <div class="card-tools">
                            <button
                              type="button"
                              class="btn btn-tool"
                              data-card-widget="collapse"
                            >
                              <i class="fas fa-minus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="card-body p-0" style="display: block">
                          <table class="table">
                            <thead>
                              <tr class="event-list-title">
                                <th class="event-date" scope="col"> {{ $t('Customer.customerFavorite.date') }}</th>
                                <th class="event-title" scope="col">
                                   {{ $t('Customer.customerFavorite.Activityname') }}
                                </th>
                                <th class="event-category" scope="col"> {{ $t('Customer.customerFavorite.type') }}</th>
                                <th class="event-region" scope="col"> {{ $t('Customer.customerFavorite.Locations') }}</th>
                                <th class="event-status" scope="col">
                                   {{ $t('Customer.customerFavorite.Registrationstatus') }}
                                </th>
                                <th class="event-bookmark" scope="col">
                                   {{ $t('Customer.customerFavorite.uncollect') }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="activity in ActivityList"
                                :key="activity.id"
                              >
                                <td class="event-date">
                                  {{ activity.sgL_ActivityDateF }}
                                </td>
                                <td class="event-title">
                                  <a
                                    target="_blank"
                                    :href="`${base.evi}/eventview/${activity.id}`"
                                    >{{ activity.sgL_Title }}</a
                                  ><span class="tooltip tooltip-inner">{{
                                    activity.sgL_KMKeyworld
                                  }}</span>
                                </td>
                                <td class="event-category">
                                  <p v-for="key in activity.sgL_TypeF">
                                    {{ key }}
                                  </p>
                                </td>
                                <td class="event-region">
                                  {{ activity.sgL_CityF }}
                                </td>
                                <td class="event-status">
                                  {{ activity.sgL_StatusF }}
                                </td>
                                <td class="event-bookmark">
                                  <i
                                    class="fas fa-bookmark fa-fw fa-sm"
                                    aria-hidden="true"
                                    @click="
                                      addfavorite(
                                        activity.id,
                                        activity.sgL_TypeId,
                                        3,
                                        null
                                      )
                                    "
                                  ></i>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header">
                          <h3 class="card-title"> {{ $t('Customer.customerFavorite.Futureactivity') }}</h3>
                          <div class="card-tools">
                            <button
                              type="button"
                              class="btn btn-tool"
                              data-card-widget="collapse"
                            >
                              <i class="fas fa-minus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="card-body p-0">
                          <table class="table">
                            <thead>
                              <tr class="event-list-title">
                                <th class="event-date" scope="col"> {{ $t('Customer.customerFavorite.date') }}</th>
                                <th class="event-title" scope="col">
                                   {{ $t('Customer.customerFavorite.Activityname') }}
                                </th>
                                <th class="event-category" scope="col"> {{ $t('Customer.customerFavorite.type') }}</th>
                                <th class="event-region" scope="col"> {{ $t('Customer.customerFavorite.Locations') }}</th>
                                <th class="event-status" scope="col">
                                   {{ $t('Customer.customerFavorite.Registrationstatus') }}
                                </th>
                                <th class="event-bookmark" scope="col">
                                   {{ $t('Customer.customerFavorite.uncollect') }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="activity in ActivityListFatrue"
                                :key="activity.id"
                              >
                                <td class="event-date">
                                  {{ activity.sgL_ActivityDatesF }} ( {{ $t('Customer.customerFavorite.day') }})
                                </td>
                                <td class="event-title">
                                  <a
                                    target="_blank"
                                    :href="`${base.evi}/eventview/${activity.id}`"
                                    >{{ activity.sgL_Title }}</a
                                  ><span class="tooltip tooltip-inner">{{
                                    activity.sgL_KMKeyworld
                                  }}</span>
                                </td>
                                <td class="event-category">
                                  <p v-for="key in activity.sgL_TypeF">
                                    {{ key }}
                                  </p>
                                </td>
                                <td class="event-region">
                                  {{ activity.sgL_CityF }}
                                </td>
                                <td class="event-status">
                                  {{ activity.sgL_StatusF }}
                                </td>
                                <td class="event-bookmark">
                                  <i
                                    class="fas fa-bookmark fa-fw fa-sm"
                                    aria-hidden="true"
                                    @click="
                                      addfavorite(
                                        activity.id,
                                        activity.sgL_TypeId,
                                        3,
                                        null
                                      )
                                    "
                                  ></i>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /.My Profile -->
              </div>

              <div class="card-body" v-show="show == 'blog'">
                <!-- My Profile -->
                <div
                  class="my-profile bookmark-event section-group"
                  v-if="blogList.length === 0"
                >
                  <div class="empty-block">
                    <div class="empty-block-inner" v-if="blogLoading">
                       {{ $t('Customer.customerFavorite.loading') }}...
                    </div>
                    <div class="empty-block-inner" v-else> {{ $t('Customer.customerFavorite.empty') }}</div>
                  </div>
                </div>
                <div class="my-profile bookmark-article section-group" v-else>
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div
                          class="col-6 col-lg-4"
                          v-for="item in blogList"
                          :key="item.id"
                        >
                          <div
                            class="article-card card"
                            @click="
                              $router.push({
                                name: 'blogDetail',
                                query: {
                                  id: item.id,
                                },
                              })
                            "
                          >
                            <div class="blog_bookmark_pic">
                              <div class="blog_bookmark_fm">
                                <a
                                  href="javascript:"
                                  :title="$t('Customer.customerFavorite.uncollect')"
                                  @click="
                                    addfavorite(
                                      item.id,
                                      item.sgL_NewTypeId,
                                      7,
                                      null
                                    )
                                  "
                                  ><i class="fas fa-bookmark fa-fw mr-3"></i>
                                </a>
                                <a
                                  href="javascript:"
                                  :title="$t('Customer.customerFavorite.share')"
                                  @click="share(item.id, 'blog')"
                                  ><i class="fa fa-share fa-fw mr-3"></i>
                                </a>
                              </div>
                              <img
                                :src="item.sgL_UploadTempUrl"
                                style="height: 100%; width: 100%"
                              />
                            </div>
                            <div class="blog_bookmark_info">
                              <p class="blog_icon_fm">
                                <img
                                  :src="item.sgL_UsersBLog"
                                  style="width: 30px"
                                /><span class="txt">{{
                                  item.sgL_BlogName
                                }}</span>
                              </p>
                              <div class="blog-title mb-2">
                                <span
                                  >{{
                                    item.sgL_Content
                                      .replace(/<\/?.+?>/g, "")
                                      .replace(/ /g, "")
                                  }}
                                </span>
                                <span class="blog-bookmark-category">{{
                                  item.sgL_NewTypeDesc
                                }}</span>
                                <span class="blog-bookmark-upload-date">{{
                                  item.sgL_CreateTimeE
                                }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row my-5">
                        <div class="col-12 col-sm-6 col-xs-4">
                          <!--  引用分页组件 -->
                          <pagination
                            v-if="getPageShow"
                            :currentPage="pageParams.currentPage"
                            :total="pageParams.total"
                            :limit="pageParams.limit"
                            :small="true"
                            @handleCurrentChange="handleCurrentChange"
                            @handleSizeChange="handleSizeChange"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /.My Profile -->
              </div>
            </div>
            <!-- /.nav-tabs-custom -->
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
    </section>
    <medalView ref="medalView" @onMedalSubmit="GetEventMedalsByUser"></medalView>
  </div>
</template>
<script>
import pagination from "../common/Page";
import bases from "../../api/httpApi/base";
import avatarVue from "../common/avatar.vue";
import medalView from "../Social/medalView.vue";
export default {
  data() {
    return {
      siteUrl: location.href.split(this.$route.path)[0],
      floading: true,
      customer: null,
      albumList: null,
      movieList: null,
      ActivityList: null,
      ActivityListFatrue: null,
      pictureList: null,
      topicList: null,
      countList: null,
      dataList: true,
      moiveCommunityList: null,
      playerOptions: {},
      show: "album",
      feedshow: "film",
      type: 0,
      feedtype: 0,
        medalListData: [],
        Runningwater:{},
      base: null,
      title: null,
      pageParams: {
        currentPage: 1,
        limit: 12,
        total: 0,
        pageshow: false,
      },
      blogList: [],
      blogLoading: false,
    };
  },
  watch: {
    type(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        this.title = null;
        this.pageParams.limit = 12;
        this.handleCurrentChange(1);
        this.pageParams.total = 0;
        this.albumList = null;
        // if (newvalue == 0 || newvalue == 1) {
        //   this.getAlbumListFavorite();
        // } else if (newvalue == 2) {
        //   this.getArticleListFavorite();
        // } else if (this.type == 3) {
        //   this.getAmovieListFavorite();
        // } else if (this.type == 4) {
        //   this.getActivityFavorite();
        // } else if (this.type == 5) {
        //   this.getSocialFavorite();
        // }
      }
    },
    title(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        if (this.type == 0 || this.type == 1) {
          this.getAlbumListFavorite();
        } else if (this.type == 2) {
          this.getArticleListFavorite();
        } else if (this.type == 3) {
          this.getAmovieListFavorite();
        } else if (this.type == 4) {
          this.getActivityFavorite();
        } else if (this.type == 5) {
          this.getSocialFavorite();
        }
      }
    },
  },
  components: {
    pagination,
    avatarVue,
    medalView
  },
  created() {
    this.base = bases;
    this.$store.dispatch("updateCurrentIndex", 0);
    this.customer = this.$store.getters.getcustomer;
    this.getAlbumListFavorite();
    this.GetFavoriteCount();
    this.GetEventMedalsByUser();
    this.SystemActivityFirst();
  },
  methods: {
         async SystemActivityFirst () {
      const params = {};
      const { data: result } = await this.$api.medalApi.SystemActivityFirst(params);
      if (!result.success) {
        result.error.code !== 500 && this.$message.error(result.error.message);
        return;
      }
       this.Runningwater = result.result ? result.result : {};
    },
                async GetEventMedalsByUser () {
      // this.loginUser.userId
      const { data: { result } } = await this.$api.common.GetEventMedalsByUser({ 'usersId': this.loginUser.userId });
      this.medalListData = result;
    },
         async showExchangePoint (Id) {
      this.$refs.medalView.setData(Id);
    },
    shareFunc(item) {
      if (!item.sgL_IsShare && item.sgL_Type == 0) {
        this.$message({
          type: "warning",
          message: "數據處理中，請稍後刷新頁面再分享",
        });
        return;
      }
      window.open(
        `${this.$shareUrl}${bases.url}/Home/facebookResp?id=${item.id}&type=moivecommunity`,
        "_blank"
      );
    },
    share(id, type) {
      let urlb = escape(`/Home/facebookResp?id=${id}&type=${type}`);
      window.open(`${this.$shareUrl}${bases.url}${urlb}`, "_blank");
    },
    onPlayerPlay(player, index) {
      player.pause();
    },
    setPlayer(id, url, poster) {
      let option = {
        playbackRates: [0.5, 1, 2, 3], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4",
            src: url,
          },
        ],
        poster: poster,
        notSupportedMessage: "此視頻暫無法播放，請稍後再試",
        // controlBar: {
        //   timeDivider: true,
        //   durationDisplay: true,
        //   remainingTimeDisplay: false,
        //   fullscreenToggle: true,
        // },
      };
      this.playerOptions[id] = option;
    },
    setPlayerOptions(list) {
      for (var i = 0; i < list.length; i++) {
        this.setPlayer(
          list[i].id,
          list[i].fileUrl,
          this.IsNullOrEmpty(list[i].sgL_ImageTempURL)
            ? list[i].jietuFileUrl
            : list[i].sgL_ImageTempURL
        );
      }
    },
    replaceArray(array) {
      let newArray =[];
      for (var i = 0; i < array.length; i++) {
        var s = array[i].replace(/\\/g, "/")
        newArray.push(s)
      }
      return newArray;
    },
    getSocialFavorite() {
      this.dataList = true;
      let params = {
        SGL_Type: this.feedtype,
        SGL_Content: this.title,
        IsLogin: true,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit, //从第几条开始查，
        MaxResultCount: this.pageParams.limit, //查多少条
      };
      this.$api.social
        .GetFavoriteByUserId(params)
        .then((res) => {
          if (res.data.success) {
            this.floading = false;
            this.setPlayerOptions(res.data.result.items);
            this.moiveCommunityList = res.data.result.items;
            let that = this;
            this.moiveCommunityList.forEach((element, i) => {
              if (element.sgL_GroupId) {
                that.moiveCommunityList[i].sgL_GroupImageTemplP = that.replaceArray(element.sgL_GroupImageTemplP)
                that.moiveCommunityList[i].sgL_GroupImageTemplS = that.replaceArray(element.sgL_GroupImageTemplS)
              }
            });


            if (this.moiveCommunityList.length <= 0) {
              this.dataList = false;
            }
            this.pageParams.total = res.data.result.totalCount;
            if (this.pageParams.total >= 1) {
              this.pageParams.pageshow = true;
            } else {
              this.pageParams.pageshow = false;
            }
          } else {
            this.dataList = false;
          }
        })
        .catch((re) => {
          this.dataList = false;
        });
    },
    getFavoriteByUserId() {
      this.blogLoading = true;
      let params = {
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit, //从第几条开始查，
        MaxResultCount: this.pageParams.limit, //查多少条
      };
      this.$api.blog
        .getFavoriteByUserId(params)
        .then(
          (res) => {
            if (res.data.success) {
              this.blogList = res.data.result.items;
              if (this.blogList.length <= 0) {
                this.blogLoading = false;
              }
              this.pageParams.total = res.data.result.totalCount;
            } else {
              this.blogLoading = false;
            }
          },
          () => {}
        )
        .then(() => {
          this.blogLoading = false;
        });
    },
    getAlbumListFavorite() {
      this.dataList = true;
      let params = {
        SGL_PG_CName: this.title,
        SGL_Fav_FType: this.type,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit, //从第几条开始查，
        MaxResultCount: this.pageParams.limit, //查多少条
      };
      this.$api.albumApi
        .getFavoriteByUserId(params)
        .then((res) => {
          if (res.data.success) {
            this.floading = false;

            this.albumList = res.data.result.items;
            if (this.albumList.length <= 0) {
              this.dataList = false;
            }
            this.pageParams.total = res.data.result.totalCount;
            if (this.pageParams.total >= 1) {
              this.pageParams.pageshow = true;
            } else {
              this.pageParams.pageshow = false;
            }
          } else {
            this.dataList = false;
          }
        })
        .catch((re) => {
          this.dataList = false;
        });
    },
    getFavoritePicture(id) {
      let params = {
        Coid: id,
        SkipCount: 0, //从第几条开始查，
        MaxResultCount: 1000, //查多少条
      };
      this.$api.albumApi.getFavoritePicture(params).then((res) => {
        if (res.data.success) {
          let ss = this.albumList.map(function (value) {
            var obj = { ...value };
            if (obj.id == params.Coid) {
              obj.pictureDtl = res.data.result.items;
            }
            return obj;
          });
          this.albumList = ss;
        }
      });
    },
    getEventListFavorite() {},
    getArticleListFavorite() {
      this.dataList = true;
      let params = {
        SGL_Title: this.title,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit, //从第几条开始查，
        MaxResultCount: this.pageParams.limit, //查多少条
      };
      this.$api.TopicApi.getFavoriteByUserId(params)
        .then((res) => {
          if (res.data.success) {
            this.floading = false;
            this.topicList = res.data.result.items;
            if (this.topicList.length <= 0) {
              this.dataList = false;
            }
            this.pageParams.total = res.data.result.totalCount;
            if (this.pageParams.total >= 1) {
              this.pageParams.pageshow = true;
            } else {
              this.pageParams.pageshow = false;
            }
          } else {
            this.dataList = false;
          }
        })
        .catch((re) => {
          this.dataList = false;
        });
    },
    getAmovieListFavorite() {
      this.dataList = true;
      let params = {
        Title: this.title,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit, //从第几条开始查，
        MaxResultCount: this.pageParams.limit, //查多少条
      };
      this.$api.VideoApi.getFavoriteByUserId(params)
        .then((res) => {
          if (res.data.success) {
            this.floading = false;
            this.movieList = res.data.result.items;
            if (this.movieList.length <= 0) {
              this.dataList = false;
            }
            this.pageParams.total = res.data.result.totalCount;
            if (this.pageParams.total >= 1) {
              this.pageParams.pageshow = true;
            } else {
              this.pageParams.pageshow = false;
            }
          } else {
            this.dataList = false;
          }
        })
        .catch((re) => {
          this.dataList = false;
        });
    },
    //獲取賽事活動個人收藏
    getActivityFavorite() {
      this.dataList = true;
      let params = {
        Title: this.title,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit, //从第几条开始查，
        MaxResultCount: 1000, //this.pageParams.limit, //查多少条
      };
      this.$api.EventApi.getFavoriteByUserId(params)
        .then((res) => {
          if (res.data.success) {
            this.floading = false;
            if (res.data.result) {
              this.ActivityList = res.data.result.items.filter(
                (x) => x.isFuture == true
              );
            } else {
              this.ActivityList = [];
            }
            if (res.data.result) {
              this.ActivityListFatrue = res.data.result.items.filter(
                (x) => x.isFuture == false
              );
            } else {
              this.ActivityListFatrue = [];
            }
            if (
              this.ActivityList.length <= 0 ||
              this.ActivityListFatrue.length <= 0
            ) {
              this.dataList = false;
            }
            this.pageParams.total = res.data.result.totalCount;
            if (this.pageParams.total >= 1) {
              this.pageParams.pageshow = true;
            } else {
              this.pageParams.pageshow = false;
            }
          } else {
            this.dataList = false;
          }
        })
        .catch((re) => {
          this.dataList = false;
        });
    },
    addfavorite(id, type, Ftype, longid) {
      let params = {
        sgL_DevicesType: 0,
        sgL_MasterSort: type, //类型
        sgL_PG_Coid: id, //图册、影片、文章、活动的id
        sgL_Fav_FType: Ftype, //图册：0，图片：1，影片：2 活动ID類型:3 新闻文章ID類型:4
        sgL_Fav_FBelongidc: longid, //图片id
      };
      this.$api.commons.addFavorite(params).then((res) => {
        if (res.data.success) {
          if (Ftype == 0 || Ftype == 1) {
            this.getAlbumListFavorite();
          } else if (Ftype == 3) {
            //this.getAmovieListFavorite();
            this.getActivityFavorite();
          } else if (Ftype == 2) {
            this.getAmovieListFavorite();
          } else if (Ftype == 4) {
            this.getArticleListFavorite();
          } else if (Ftype == 5) {
            this.getSocialFavorite();
          } else if (Ftype == 7) {
            this.getFavoriteByUserId();
          }
          this.GetFavoriteCount();
        }
      });
    },
    GetFavoriteCount() {
      this.$api.commons.GetFavoriteCount().then((res) => {
        if (res.data.success) {
          this.countList = res.data.result;
        }
      });
    },
    showContent(type) {
      this.show = type;
      if (type == "picture") {
        this.type = 1;
      } else if (type == "album") {
        this.type = 0;
      } else if (type == "topic") {
        this.type = 2;
      } else if (type == "movie") {
        this.type = 3;
      } else if (type == "activity") {
        this.type = 4;
      } else if (type == "feed") {
        this.type = 5;
        this.feedshowContent('film');
      } else if (type == "blog") {
        this.type = 6;
      }
    },
    feedshowContent(type) {
      this.feedshow = type;
      this.moiveCommunityList = null;
      if (type == "photo") {
        this.feedtype = 1;
      } else if (type == "film") {
        this.feedtype = 0;
      } else if (type == "text") {
        this.feedtype = 2;
      }
      this.getSocialFavorite();
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      if (this.type == 0 || this.type == 1) {
        this.getAlbumListFavorite();
      } else if (this.type == 2) {
        this.getArticleListFavorite();
      } else if (this.type == 3) {
        this.getAmovieListFavorite();
      } else if (this.type == 4) {
        this.getActivityFavorite();
      } else if (this.type == 5) {
        this.getSocialFavorite();
      } else if (this.type == 6) {
        this.getFavoriteByUserId();
      }
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      if (this.type == 0 || this.type == 1) {
        this.getAlbumListFavorite();
      } else if (this.type == 2) {
        this.getArticleListFavorite();
      } else if (this.type == 3) {
        this.getAmovieListFavorite();
      } else if (this.type == 4) {
        this.getActivityFavorite();
      } else if (this.type == 5) {
        this.getSocialFavorite();
      }
    },
  },
  computed: {
    getPageShow() {
      return this.pageParams.pageshow;
    },
    customers () {
      return this.$store.getters.getcustomer;
    },
    getalbumList() {
      if (this.albumList == null || this.albumList.length == 0) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.album-image .video-player {
  width: 100%;
  height: 100%;
}
.album-image .video-player >>> .video-js {
  width: 100%;
  height: 100%;
}
.album-image .video-player >>> .vjs-control-bar {
  font-size: 1em;
  display: none;
}
.album-image .video-player >>> .vjs-big-play-button {
  font-size: 1.5em;
}
.search2 >>> input {
  width: 100%;
  border-radius: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/Customer/customerFavorite.vue